import { useGenericModal } from '..';
import {
  CreateSolutionModal,
  CreateSolutionModalProps,
} from './create-solution-modal';

export const useCreateSolutionModal = (
  props?: Partial<CreateSolutionModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const modalComponent = (
    <CreateSolutionModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
    />
  );

  return {
    modalRef,
    openModal,
    closeModal,
    createSolutionModal: modalComponent,
  };
};
